import { useAnalyticsIdentity } from "@/hooks/use-analytics-identity";
import { useAnalyticsPageview } from "@/hooks/use-analytics-pageview";

/**
 * Draws nothing. It exists so that the reporting that has to run for the whole
 * signed-in session has somewhere to live inside the router and the auth
 * provider, without the routing component taking on the job.
 */
export function AnalyticsReporter() {
  useAnalyticsIdentity();
  useAnalyticsPageview();
  return null;
}
